var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PagedCollection } from "@auvious/common";
export class InteractionService {
    constructor(commonSource) {
        commonSource.subscribe((common) => {
            this.apiResource = common.apiResourceFactory("rtc-api/interactions");
        });
    }
    /**
     * Creates an interaction on the Auvious platform.
     * @param interactionId interactionId, can be null if you want the server to create one.
     * @param type type of interaction can be any string
     * @param data data is a map with string keys and values can be anything
     * @returns the interaction id which should be the same with interactionId param, if it was not null
     */
    create(interactionId, type, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.create({
                interactionId,
                type,
                data,
            });
            return response.interactionId;
        });
    }
    /**
     * Find an interaction by it's id.
     *
     * @param interactionId id of interaction to look for
     * @returns the interaction if found
     */
    get(interactionId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.apiResource.get({
                urlPostfix: `/${interactionId}`,
            }));
        });
    }
    /**
     * Get all interactions of the user organization, between start and end date, as a page.
     * @param start start date
     * @param end end date
     * @param offset offset to apply
     * @param page page number
     * @param pageSize page size
     */
    getPage(start, end, page, pageSize, sort = "createdAt,desc", filters = {}) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            params.set("start", start.toISOString());
            params.set("end", end.toISOString());
            params.set("sort", `${sort}`);
            params.set("page", `${page}`);
            params.set("size", `${pageSize}`);
            if (((_a = filters === null || filters === void 0 ? void 0 : filters.userIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                params.set("userId", filters.userIds.join(","));
            }
            if (((_b = filters === null || filters === void 0 ? void 0 : filters.recording) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                params.set("recording", filters.recording.join(","));
            }
            if (((_c = filters === null || filters === void 0 ? void 0 : filters.type) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                params.set("type", filters.type.join(","));
            }
            return new PagedCollection(yield this.apiResource.get({
                params,
            }));
        });
    }
    /**
     * Update interaction type and/or data.
     *
     * @param interactionId id of interaction to update
     * @param type if not null, type will be updated to this type
     * @param data if not null, data will be set to this value
     */
    update(interactionId, type, data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiResource.update({
                interactionId,
                type,
                data,
            }, {
                urlPostfix: `/${interactionId}`,
            });
        });
    }
}
